import { TextFieldProps } from '@blueshift-ui/inputs';
import { Control, RegisterOptions, useForm } from 'react-hook-form';
import ControlledTextField from './controlled-text-field';

type EmailFieldProps<T extends { email: string }> = {
  control?: Control<T>;
  rules?: Omit<RegisterOptions<T>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>;
} & TextFieldProps;

function EmailField<T extends { email: string }>({
  control,
  rules = {
    required: 'Email is required',
  },
  ...fieldProps
}: EmailFieldProps<T>) {
  const { control: defaultControl } = useForm({ mode: 'onChange' });

  return (
    <ControlledTextField
      control={control || defaultControl}
      controllerProps={{ rules }}
      fullWidth
      InputLabelProps={{ shrink: true }}
      label="Email"
      name="email"
      type="email"
      {...fieldProps}
    />
  );
}

export default EmailField;
